var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1742_7591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9175 0H4.0825C1.8278 0 0 1.8278 0 4.0825V39.9175C0 42.1722 1.8278 44 4.0825 44H39.9175C42.1722 44 44 42.1722 44 39.9175V4.0825C44 1.8278 42.1722 0 39.9175 0Z",
    fill: "#EB0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1071 15.3856C34.5571 13.6931 32.7371 12.6681 31.0621 12.4331C25.0374 11.7931 18.9619 11.7931 12.9371 12.4331C11.2621 12.6681 9.43714 13.6831 8.89214 15.3856C8.03465 19.7548 8.03465 24.249 8.89214 28.6181C9.44214 30.3081 11.2621 31.3356 12.9371 31.5706C18.9619 32.2106 25.0374 32.2106 31.0621 31.5706C32.7371 31.3356 34.5621 30.3206 35.1071 28.6181C35.9646 24.249 35.9646 19.7548 35.1071 15.3856ZM18.7096 27.2706V16.7306L27.2896 22.0006C24.3971 23.7781 21.5896 25.5006 18.7096 27.2706Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1742_7591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.7ccd4f6b4fae79a3b77bb18e2eb89a33.svg";
export { ForwardRef as ReactComponent };